export const STORE_CLEAR = 'STORE_CLEAR';
export const STORE_CLEAR_FOR_DASHBOARD = 'STORE_CLEAR_FOR_DASHBOARD';
